<template>
  <div class="tools-cards-grid atb-py-8">
    <Card
      id="multiDatasourceCard"
      class="tools-card atb-text-center pointer"
      v-on:click="() => changeTab('3')"
    >
      <template #body>
        <div
          class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
        >
          <img
            alt="multidatasource icon"
            class="icon atb-w-12 atb-h-12"
            src="@/app/images/multidatasource.svg"
          />
          <h4 class="atb-text-lg">
            <a href="#">{{ $t('multiDatasource') }}</a>
          </h4>
          <p class="card-text atb-text-black">
            {{ $t('multiDatasourceSummary') }}
          </p>
        </div>
      </template>
    </Card>
    <Card class="tools-card atb-text-center disabler">
      <template #body>
        <div
          class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
          :title="$t('comingSoon')"
        >
          <img
            alt="reports icon"
            class="icon atb-w-12 atb-h-12"
            src="@/app/images/attributes.svg"
          />
          <h4 class="atb-text-lg">
            <a href="#"> {{ $t('reports') }}</a>
          </h4>
          <p class="card-text atb-text-black">
            {{ $t('reportsSummary') }}
          </p>
        </div>
      </template>
    </Card>
    <Card
      v-if="AccessGuard.hasAccess('IMPORT')"
      class="tools-card atb-text-center pointer"
      v-on:click="() => changeTab('2')"
    >
      <template #body>
        <div
          class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
        >
          <img
            alt="import icon"
            class="icon atb-w-12 atb-h-12"
            src="@/app/images/import.svg"
          />
          <h4 class="atb-text-lg">
            <a href="#">{{ $t('import') }}</a>
          </h4>
          <p class="card-text atb-text-black">
            {{ $t('importSummary') }}
          </p>
        </div>
      </template>
    </Card>
    <Card
      v-if="AccessGuard.hasAccess('EXPORT')"
      class="tools-card atb-text-center pointer"
      v-on:click="() => changeTab('1')"
    >
      <template #body>
        <div
          class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
        >
          <img
            alt="export icon"
            class="icon atb-w-12 atb-h-12"
            src="@/app/images/export.svg"
          />
          <h4 class="atb-text-lg">
            <a href="#">{{ $t('export') }}</a>
          </h4>
          <p class="card-text atb-text-black">
            {{ $t('exportSummary') }}
          </p>
        </div>
      </template>
    </Card>
  </div>
</template>

<script lang="ts" setup>
  import Card from '@atb-ui/eds-vue/src/components/Card.vue';
  import AccessGuard from '@/app/shared/guards/access-guard';

  interface ToolsHomeEvent {
    (_event: 'changeTab', _tab: string): void;
  }
  const emit = defineEmits<ToolsHomeEvent>();

  const changeTab = (tab: string) => {
    emit('changeTab', tab);
  };
</script>

<style>
  .tools-cards-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    padding: 0 3rem;
    max-width: 750px;
    margin: 0 auto;
    align-items: stretch;
    justify-items: stretch;
  }
  .tools-cards-grid > .tools-card.eds-card {
    width: auto;
    min-width: 0;
    height: 220px;
  }
  .tools-card .card-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .pointer {
    cursor: pointer;
  }
  .disabler {
    opacity: 0.5;
  }
</style>
